<ng-container [formGroup]="form">
    <mat-form-field apperance="fill" [ngClass]="class" class="w-full">
        <mat-label *ngIf="label"> {{ label | transloco }}</mat-label>
        <input
            autocomplete="new-password"
            [attr.readonly]="readonly"
            *ngIf="type !== 'textarea'; else textarea"
            [type]="type"
            [attr.min]="min"
            [attr.max]="max"
            (click)="press.emit(form.get(controlName).value)"
            matInput
            placeholder="{{ label | transloco }}"
            [formControlName]="controlName"
        />
        <mat-hint *ngIf="hint">{{ hint | transloco }}</mat-hint>

        <ng-content select="[addIcons]"></ng-content>
        <ng-template #textarea>
            <textarea
                [type]="type"
                matInput
                placeholder="{{ label | transloco }}"
                [formControlName]="controlName"
            ></textarea>
        </ng-template>
        <mat-error *ngIf="form.get(controlName)?.hasError('required')">
            {{ label | transloco }} {{ "Is Required" | transloco }}</mat-error
        >
        <mat-error *ngIf="form.get(controlName)?.hasError('codeUsedBefore')">
            {{ form.get(controlName).value }}
            {{ "Used Before" | transloco }}</mat-error
        >
        <mat-error *ngIf="form.get(controlName)?.errors?.email">
            {{ "Please Enter a valid Email Address" | transloco }}</mat-error
        >
        <mat-error *ngIf="form.get(controlName)?.errors?.pattern">
            {{ "can't accept empty string" | transloco }}</mat-error
        >
        <mat-error *ngIf="form.get(controlName)?.errors?.min">
            {{ "Value Must" | transloco }}
            {{ ">=" + form.get(this.controlName).errors?.min?.min }}</mat-error
        >
        <mat-error *ngIf="form.get(controlName)?.errors?.max">
            {{ "Value Must" | transloco }}
            {{
                "
            <=" + form.get(this.controlName).errors?.max?.max
            }}</mat-error
        >
        <mat-error *ngIf="form.get(controlName)?.errors?.minlength">
            {{ " Length Must " | transloco }}
            {{
                ">=" +
                    form.get(this.controlName).errors?.minlength?.requiredLength
            }}</mat-error
        >
        <mat-error *ngIf="form.get(controlName)?.errors?.maxlength"
            >{{ "Length Must" | transloco }}
            {{
                "
            <=" + form.get(this.controlName).errors?.maxlength?.requiredLength
            }}
        </mat-error>
        <mat-error *ngIf="form.get(controlName)?.hasError('whitespace')"
            >must not start or end with space</mat-error
        >
    </mat-form-field>
</ng-container>
